// Dev-only fake clock (inert in prod builds, plain `vite dev` and vitest) — must stay the FIRST import.
import './dev/fakeClock'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'
import { trpc, createTrpcClient, createQueryClient } from './trpc'
import './scss/global.scss'
import { clientRoutes } from './routes-map'

const queryClient = createQueryClient()
const trpcClient = createTrpcClient() // defaults url to '/trpc' → Vite dev proxy → :8080

const router = createBrowserRouter(clientRoutes)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </trpc.Provider>
  </React.StrictMode>,
)
